module.exports = __webpack_public_path__ + "img/Circular.813ea927.svg";